<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: $t('request_form') }"
    :key="$i18n.locale"
    @action="handleAction"
    @reload="handleReload"
    :reloadable="true"
  >
    <v-card flat class="pa-2">
      <custom-tabs
        v-model="tabs"
        :tab-items="[
          { text: $t('form.form_download'), icon: 'file-download' },
          { text: $t('form.form_add'), icon: 'list-box-outline' },
        ]"
        grow
      >
        <template v-slot:staticItems>
          <v-tab-item>
            <consultation-awnser
              :qr_id="qr_id ?? info?.id"
              ref="consultationAwnser"
            />
          </v-tab-item>
          <v-tab-item>
            <consultation-new
              :info="info"
              v-model="info.data.data"
              ref="consultationNew"
            />
          </v-tab-item>
        </template>
      </custom-tabs>
    </v-card>
  </custom-popup>
</template>

<script>
import ConsultationAwnser from "./consultationAwnser.vue";
import consultationNew from "./consultationNew.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: { consultationNew, ConsultationAwnser },
  name: "consultationPop",
  props: {
    value: Boolean,    
    address: String,
  },

  computed: {
    ...mapState("local", ["qr_id", "qrInfo"]),

    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  data() {
    return {
      info:{},
      tabs: null,
    };
  },

  methods: {
     fetchData() {
      this.loading = true;
      console.log(this.address, "consulationPOP");
      
      return this.$api
        .get(`/v1/testQr/find/${this.address}`)
        .then(({ data }) => {
          this.info = data.data;
        })
        .finally(() => (this.loading = false));
    },


    handleReload() {
      if (this.tabs === 0 && this.$refs.consultationAwnser) {
        this.$refs.consultationAwnser.fetch();
      }
    },
    handleAction(actionType) {
      if (actionType === "submit" && this.$refs.consultationNew) {
        this.$refs.consultationNew.update();
      }
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
     dialog(val) {
      if (val) {
        this.fetchData();
      } else {
        this.tabs = 0;
      }
    },
    },
};
</script>

<style></style>
